export default __webpack_public_path__ + "b0d2351abccec19f38a2cb6b2c32c15f.svg";